import * as React from "react";
const SvgStandard = (props) => /* @__PURE__ */ React.createElement("svg", {
	id: "Standard",
	xmlns: "http://www.w3.org/2000/svg",
	width: 139.66,
	height: 73.975,
	viewBox: "0 0 139.66 73.975",
	...props
}, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("style", null, "\r\n      .standard-cls-1 {\r\n        fill: #3f3d56;\r\n      }\r\n\r\n      .standard-cls-2 {\r\n        fill: #939d9e;\r\n      }\r\n\r\n      .standard-cls-3 {\r\n        fill: #e6e6e6;\r\n      }\r\n\r\n      .standard-cls-4 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .standard-cls-5, .standard-cls-7 {\r\n        fill: #747678;\r\n      }\r\n\r\n      .standard-cls-6 {\r\n        fill: #707070;\r\n      }\r\n\r\n      .standard-cls-7 {\r\n        font-size: 15px;\r\n        font-family: Montserrat-Regular, Montserrat;\r\n      }\r\n    ")), /* @__PURE__ */ React.createElement("path", {
	id: "Path_393",
	"data-name": "Path 393",
	className: "standard-cls-1",
	d: "M476.557,562.186a.518.518,0,0,0-.518.518v20.675a.518.518,0,0,0,.518.518h3.51a.518.518,0,0,0,.518-.518V562.7a.518.518,0,0,0-.517-.518Z",
	transform: "translate(-423.155 -510.168)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_394",
	"data-name": "Path 394",
	className: "standard-cls-1",
	d: "M694.4,562.186a.518.518,0,0,0-.518.518v20.675a.518.518,0,0,0,.518.518h3.51a.518.518,0,0,0,.518-.518V562.7a.518.518,0,0,0-.518-.518Z",
	transform: "translate(-611.809 -510.168)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_395",
	"data-name": "Path 395",
	className: "standard-cls-1",
	d: "M490.184,252.218l-26.911-2.078,21.469,3.661,5.145-.89Z",
	transform: "translate(-391.2 -216.626)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_396",
	"data-name": "Path 396",
	className: "standard-cls-2",
	d: "M486.219,253.475l5.145-.89.051-.118.246.019-.3.693-5.145.89L464.75,250.14l6.362.759Z",
	transform: "translate(-392.479 -216.626)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_397",
	"data-name": "Path 397",
	className: "standard-cls-1",
	d: "M35.307,252.218,8.4,250.14,29.865,253.8l5.145-.89Z",
	transform: "translate(2.738 -216.626)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_398",
	"data-name": "Path 398",
	className: "standard-cls-2",
	d: "M27.65,253.475l5.145-.89.051-.118.246.019-.3.693-5.145.89L6.181,250.14l6.362.759Z",
	transform: "translate(4.656 -216.626)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_399",
	"data-name": "Path 399",
	className: "standard-cls-1",
	d: "M423.072,486.818l-2.276.1-20.847,8.8-1.193,1-3.782,3.166H383.1l-3.576-3.166-1.359-1.2-20-8.492-1.781-.2,5.936-2.869h.032c1.346-1.277,13-2.276,27.176-2.276s25.83,1,27.176,2.276h.131Z",
	transform: "translate(-319.536 -440.442)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_400",
	"data-name": "Path 400",
	className: "standard-cls-1",
	d: "M344.9,430.375a1.109,1.109,0,0,0,.064-.369v-4.7a1.113,1.113,0,0,0-1.113-1.113H343.4a2.671,2.671,0,1,0-3.8,0h-.452a1.113,1.113,0,0,0-1.113,1.113v4.7a1.107,1.107,0,0,0,.145.549c-.336.059-.672.123-1.008.2a.921.921,0,0,0-.72.9v1.116a.923.923,0,0,0,.923.923H347.83v-2.77A23.8,23.8,0,0,0,344.9,430.375Z",
	transform: "translate(-302.269 -386.721)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_401",
	"data-name": "Path 401",
	className: "standard-cls-1",
	d: "M792.386,430.75c-.336-.074-.672-.138-1.008-.2a1.107,1.107,0,0,0,.145-.549v-4.7a1.113,1.113,0,0,0-1.113-1.113h-.452a2.671,2.671,0,1,0-3.8,0h-.452a1.113,1.113,0,0,0-1.113,1.113V430a1.109,1.109,0,0,0,.064.369,23.8,23.8,0,0,0-2.933.546v2.77h10.455a.923.923,0,0,0,.923-.923v-1.116A.921.921,0,0,0,792.386,430.75Z",
	transform: "translate(-687.891 -386.721)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_402",
	"data-name": "Path 402",
	className: "standard-cls-1",
	d: "M681.85,252.218l26.911-2.078L687.292,253.8l-5.145-.89Z",
	transform: "translate(-580.495 -216.626)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_403",
	"data-name": "Path 403",
	className: "standard-cls-1",
	d: "M581.058,610.9h-4.175a1.178,1.178,0,0,0-1.178,1.177v.91a1.177,1.177,0,0,0,.761,1.1,1.151,1.151,0,0,0-.267.738v.261a1.154,1.154,0,0,0,.495.947v3.473h4.551v-3.473a1.154,1.154,0,0,0,.495-.947v-.261a1.15,1.15,0,0,0-.267-.738,1.177,1.177,0,0,0,.761-1.1v-.91a1.178,1.178,0,0,0-1.178-1.178Z",
	transform: "translate(-509.469 -552.354)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_404",
	"data-name": "Path 404",
	className: "standard-cls-2",
	d: "M563.876,671.475a.7.7,0,0,0-.7.7v5.616a.7.7,0,0,0,.7.7h8.485a.7.7,0,0,0,.7-.7v-5.616a.7.7,0,0,0-.7-.7Z",
	transform: "translate(-498.617 -604.814)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_405",
	"data-name": "Path 405",
	className: "standard-cls-2",
	d: "M548.31,583.683l-3.782,3.166H532.656l-3.576-3.166h3.556l.155-.775a1,1,0,0,1,.985-.808H543.7a1,1,0,0,1,.985.808l.155.775Z",
	transform: "translate(-469.09 -527.414)"
}), /* @__PURE__ */ React.createElement("circle", {
	id: "Ellipse_68",
	"data-name": "Ellipse 68",
	className: "standard-cls-1",
	cx: 2.77,
	cy: 2.77,
	r: 2.77,
	transform: "translate(66.731 67.4)"
}), /* @__PURE__ */ React.createElement("circle", {
	id: "Ellipse_69",
	"data-name": "Ellipse 69",
	className: "standard-cls-3",
	cx: 1.583,
	cy: 1.583,
	r: 1.583,
	transform: "translate(67.919 68.587)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_406",
	"data-name": "Path 406",
	className: "standard-cls-4",
	d: "M592.893,688.269a1.581,1.581,0,0,1-2.216,2.216,1.582,1.582,0,1,0,2.216-2.216Z",
	transform: "translate(-522.434 -619.358)"
}), /* @__PURE__ */ React.createElement("rect", {
	id: "Rectangle_1179",
	"data-name": "Rectangle 1179",
	className: "standard-cls-3",
	width: 71.027,
	height: .453,
	transform: "translate(34.235 45.209)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_407",
	"data-name": "Path 407",
	className: "standard-cls-2",
	d: "M688.769,253.475l-5.145-.89-.051-.118-.246.019.3.693,5.145.89,21.469-3.929-6.362.759Z",
	transform: "translate(-581.774 -216.626)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_408",
	"data-name": "Path 408",
	className: "standard-cls-1",
	d: "M226.973,252.218l26.911-2.078L232.414,253.8l-5.145-.89Z",
	transform: "translate(-186.557 -216.626)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_409",
	"data-name": "Path 409",
	className: "standard-cls-2",
	d: "M234.63,253.475l-5.145-.89-.051-.118-.246.019.3.693,5.145.89L256.1,250.14l-6.362.759Z",
	transform: "translate(-188.477 -216.626)"
}), /* @__PURE__ */ React.createElement("rect", {
	id: "Rectangle_1180",
	"data-name": "Rectangle 1180",
	className: "standard-cls-3",
	width: 7.915,
	height: 1.583,
	transform: "translate(65.693 55.527)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_410",
	"data-name": "Path 410",
	className: "standard-cls-3",
	d: "M235.384,173.935H211.392a3.214,3.214,0,0,0-3.211,3.211v12.738a3.214,3.214,0,0,0,3.211,3.211h23.992a3.214,3.214,0,0,0,3.211-3.211V177.146a3.214,3.214,0,0,0-3.211-3.211Z",
	transform: "translate(-208.181 -173.935)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_411",
	"data-name": "Path 411",
	className: "standard-cls-4",
	d: "M228.279,193.435a.6.6,0,0,0-.6.6v12.738a.6.6,0,0,0,.6.6h23.992a.6.6,0,0,0,.6-.6V194.033a.6.6,0,0,0-.6-.6Z",
	transform: "translate(-225.068 -190.822)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_412",
	"data-name": "Path 412",
	className: "standard-cls-3",
	d: "M513.384,173.935H489.392a3.214,3.214,0,0,0-3.211,3.211v12.738a3.214,3.214,0,0,0,3.211,3.211h23.992a3.214,3.214,0,0,0,3.211-3.211V177.146a3.215,3.215,0,0,0-3.211-3.211Z",
	transform: "translate(-448.938 -173.935)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_413",
	"data-name": "Path 413",
	className: "standard-cls-4",
	d: "M506.279,193.435a.6.6,0,0,0-.6.6v12.738a.6.6,0,0,0,.6.6h23.992a.6.6,0,0,0,.6-.6V194.033a.6.6,0,0,0-.6-.6Z",
	transform: "translate(-465.825 -190.822)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_414",
	"data-name": "Path 414",
	className: "standard-cls-3",
	d: "M791.384,173.935H767.392a3.214,3.214,0,0,0-3.211,3.211v12.738a3.214,3.214,0,0,0,3.211,3.211h23.992a3.214,3.214,0,0,0,3.211-3.211V177.146a3.214,3.214,0,0,0-3.211-3.211Z",
	transform: "translate(-689.694 -173.935)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_415",
	"data-name": "Path 415",
	className: "standard-cls-4",
	d: "M784.279,193.435a.6.6,0,0,0-.6.6v12.738a.6.6,0,0,0,.6.6h23.992a.6.6,0,0,0,.6-.6V194.033a.6.6,0,0,0-.6-.6Z",
	transform: "translate(-706.581 -190.822)"
}), /* @__PURE__ */ React.createElement("rect", {
	id: "Rectangle_1181",
	"data-name": "Rectangle 1181",
	className: "standard-cls-1",
	width: 139.651,
	height: .3,
	transform: "translate(0.009 73.674)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Icon_awesome-map",
	"data-name": "Icon awesome-map",
	className: "standard-cls-5",
	d: "M0,4.039v7.233a.334.334,0,0,0,.458.31L3.342,10.27V2.25L.42,3.419A.668.668,0,0,0,0,4.039ZM4.01,10.27l4.01,1.337V3.587L4.01,2.25Zm7.562-8L8.689,3.587v8.02l2.922-1.169a.668.668,0,0,0,.42-.621V2.585A.334.334,0,0,0,11.572,2.274Z",
	transform: "translate(9.179 2.5)"
}), /* @__PURE__ */ React.createElement("circle", {
	id: "Ellipse_70",
	"data-name": "Ellipse 70",
	className: "standard-cls-6",
	cx: 1,
	cy: 1,
	r: 1,
	transform: "translate(82.123 12)"
}), /* @__PURE__ */ React.createElement("circle", {
	id: "Ellipse_71",
	"data-name": "Ellipse 71",
	className: "standard-cls-6",
	cx: 1,
	cy: 1,
	r: 1,
	transform: "translate(84.123 9)"
}), /* @__PURE__ */ React.createElement("circle", {
	id: "Ellipse_72",
	"data-name": "Ellipse 72",
	className: "standard-cls-6",
	cx: 1,
	cy: 1,
	r: 1,
	transform: "translate(88.123 8)"
}), /* @__PURE__ */ React.createElement("circle", {
	id: "Ellipse_73",
	"data-name": "Ellipse 73",
	className: "standard-cls-6",
	cx: 1,
	cy: 1,
	r: 1,
	transform: "translate(92.123 9)"
}), /* @__PURE__ */ React.createElement("circle", {
	id: "Ellipse_74",
	"data-name": "Ellipse 74",
	className: "standard-cls-6",
	cx: 1,
	cy: 1,
	r: 1,
	transform: "translate(95.123 7)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_416",
	"data-name": "Path 416",
	className: "standard-cls-3",
	d: "M513.384,173.935H489.392a3.214,3.214,0,0,0-3.211,3.211v12.738a3.214,3.214,0,0,0,3.211,3.211h23.992a3.214,3.214,0,0,0,3.211-3.211V177.146a3.215,3.215,0,0,0-3.211-3.211Z",
	transform: "translate(-376.944 -173.935)"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_417",
	"data-name": "Path 417",
	className: "standard-cls-4",
	d: "M506.279,193.435a.6.6,0,0,0-.6.6v12.738a.6.6,0,0,0,.6.6h23.992a.6.6,0,0,0,.6-.6V194.033a.6.6,0,0,0-.6-.6Z",
	transform: "translate(-393.83 -190.822)"
}), /* @__PURE__ */ React.createElement("text", {
	id: "_",
	"data-name": "+",
	className: "standard-cls-7",
	transform: "translate(52.125 15)"
}, /* @__PURE__ */ React.createElement("tspan", {
	x: -3.705,
	y: 0
}, "+")), /* @__PURE__ */ React.createElement("path", {
	id: "Icon_material-3d-rotation",
	"data-name": "Icon material-3d-rotation",
	className: "standard-cls-5",
	d: "M2.717,7.6a3.709,3.709,0,0,1-2.112-3H.075A4.242,4.242,0,0,0,4.3,8.489l.233-.011L3.188,7.131Zm.315-2.306a.59.59,0,0,1-.184-.028.378.378,0,0,1-.141-.085.351.351,0,0,1-.092-.131.422.422,0,0,1-.032-.166h-.46a.724.724,0,0,0,.074.336.782.782,0,0,0,.2.244.893.893,0,0,0,.29.145,1.067,1.067,0,0,0,.34.053,1.193,1.193,0,0,0,.364-.053.862.862,0,0,0,.294-.156A.7.7,0,0,0,3.877,5.2a.826.826,0,0,0,.071-.343.742.742,0,0,0-.025-.2.591.591,0,0,0-.081-.18A.636.636,0,0,0,3.7,4.322a.727.727,0,0,0-.216-.11A.742.742,0,0,0,3.669,4.1.731.731,0,0,0,3.8,3.947a.623.623,0,0,0,.078-.163.564.564,0,0,0,.025-.17.855.855,0,0,0-.064-.34.63.63,0,0,0-.18-.244.728.728,0,0,0-.272-.152,1.289,1.289,0,0,0-.361-.05,1.045,1.045,0,0,0-.354.057.9.9,0,0,0-.279.159.8.8,0,0,0-.18.237.7.7,0,0,0-.064.3h.46a.376.376,0,0,1,.032-.159.332.332,0,0,1,.088-.12.419.419,0,0,1,.134-.078.518.518,0,0,1,.17-.028.406.406,0,0,1,.315.11.427.427,0,0,1,.1.3.539.539,0,0,1-.028.173.308.308,0,0,1-.088.131A.449.449,0,0,1,3.188,4a.6.6,0,0,1-.205.032H2.71V4.4h.272a.8.8,0,0,1,.212.025.423.423,0,0,1,.159.081.417.417,0,0,1,.1.141.5.5,0,0,1,.035.2.424.424,0,0,1-.124.329.453.453,0,0,1-.336.117ZM6.056,3.2a1.178,1.178,0,0,0-.4-.272,1.331,1.331,0,0,0-.516-.1H4.3v2.83h.814a1.436,1.436,0,0,0,.534-.1,1.166,1.166,0,0,0,.41-.269,1.194,1.194,0,0,0,.262-.421,1.618,1.618,0,0,0,.092-.555V4.177a1.618,1.618,0,0,0-.092-.555A1.236,1.236,0,0,0,6.056,3.2ZM5.918,4.315a1.545,1.545,0,0,1-.05.4.86.86,0,0,1-.152.3.661.661,0,0,1-.251.187.909.909,0,0,1-.35.064H4.793V3.226h.343a.7.7,0,0,1,.58.244,1.077,1.077,0,0,1,.2.7v.141ZM4.3,0,4.068.011,5.416,1.358l.47-.47a3.7,3.7,0,0,1,2.108,3h.531A4.236,4.236,0,0,0,4.3,0Z",
	transform: "translate(119.629 5.5)"
}));
export default SvgStandard;
